export const defaultState = {
  quotes: {},
  currentQuotes: {},
};

export default {
  ...defaultState,
};
